import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Youtube, Instagram } from 'lucide-react';

const activeRoutes = [
    '/about-us',
    '/contact-us',
    '/careers',
    '/'
];

const FooterLink = ({ to, children, className }) => {
    const isActive = activeRoutes.includes(to);

    if (!isActive) {
        return (
            <Link
                to={to}
                onClick={(e) => e.preventDefault()}
                className={`cursor-default text-gray-400`}
                title="Coming Soon"
            >
                {children}
            </Link>
        );
    }

    return (
        <Link to={to} className={className || "hover:text-brand-gold transition-colors"}>
            {children}
        </Link>
    );
};

const Footer = () => {
    return (
        <footer className="bg-brand-card border-t border-gray-800 text-brand-textMuted py-16 mt-16 text-sm">
            <div className="w-full px-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                    {/* Brand Column */}
                    <div className="lg:col-span-1 space-y-6">
                        <h2 className="text-3xl font-bold text-brand-textLight tracking-tight">AIGenius</h2>

                        <div className="pt-4">

                            <p className="font-semibold text-brand-textLight mb-4">Give us a ring!</p>
                            <a
                                href="tel:985-060-3297"
                                className="inline-block bg-[#0B1120] text-white text-xl font-bold py-3 px-6 rounded-md hover:bg-gray-800 transition-colors"
                            >
                                920 984 7327
                            </a>
                            <p className="font-semibold text-brand-textLight mb-4 mt-4">Or mail us on </p>
                            <a href="mailto:radhakrishna.naik@aigenuis.co.in">
                                radhakrishna.naik@aigenuis.co.in
                            </a>
                        </div>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-brand-textLight font-bold uppercase tracking-wider mb-6">What We Do</h3>
                        <ul className="space-y-3">
                            <li><FooterLink to="/services/ai-ds" className="hover:text-brand-gold transition-colors">AI & DS</FooterLink></li>
                            <li><FooterLink to="/services/genai" className="hover:text-brand-gold transition-colors">GenAI</FooterLink></li>
                            <li><FooterLink to="/services/edge-ai" className="hover:text-brand-gold transition-colors">Edge AI</FooterLink></li>
                            <li><FooterLink to="/services/devops" className="hover:text-brand-gold transition-colors">Devops</FooterLink></li>
                            <li><FooterLink to="/services/cybersecurity" className="hover:text-brand-gold transition-colors">Cybersecurity</FooterLink></li>
                        </ul>
                    </div>

                    {/* What We Do */}
                    <div>
                        <h3 className="text-brand-textLight font-bold uppercase tracking-wider mb-6">Services</h3>
                        <ul className="space-y-3">
                            <li className="cursor-default">Product development in AI and ML</li>
                            <li className="cursor-default">Consulting</li>
                            <li className="cursor-default">Project development</li>
                            <li className="cursor-default">Corporate training</li>
                            <li className="cursor-default">Strategic decision service</li>
                        </ul>
                    </div>

                    {/* Resources */}
                    <div>
                        <h3 className="text-brand-textLight font-bold uppercase tracking-wider mb-6">Resources</h3>
                        <ul className="space-y-3">
                            <li><FooterLink to="/about-us" className="hover:text-brand-gold transition-colors">About Us</FooterLink></li>
                            <li><FooterLink to="/contact-us" className="hover:text-brand-gold transition-colors">Contact Us</FooterLink></li>
                            <li><FooterLink to="/careers" className="hover:text-brand-gold transition-colors">Careers</FooterLink></li>
                        </ul>
                    </div>


                </div>

                {/* Bottom Bar */}
                <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-center text-xs text-gray-500">
                        <div className="font-bold text-brand-textLight tracking-wide">
                            PROUDLY BROUGHT TO YOU BY AIGenius
                        </div>
                        <div>
                            AIGenius® 2026
                        </div>
                        <div className="flex gap-4">
                            <FooterLink to="/sitemap" className="hover:text-brand-gold">Sitemap</FooterLink>
                            <FooterLink to="/privacy" className="hover:text-brand-gold">Privacy & Terms of Use</FooterLink>
                        </div>
                    </div>

                    <div className="flex gap-4">
                        <a href="https://www.facebook.com/share/1EVPSZMdrQ/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="p-2 bg-gray-100 rounded-full text-brand-textMuted hover:bg-gray-200 hover:text-brand-gold transition-colors">
                            <Facebook size={18} />
                        </a>
                        <button type="button" aria-label="Twitter" className="p-2 bg-gray-100 rounded-full text-brand-textMuted hover:bg-gray-200 hover:text-brand-gold transition-colors">
                            <Twitter size={18} />
                        </button>
                        <button type="button" aria-label="LinkedIn" className="p-2 bg-gray-100 rounded-full text-brand-textMuted hover:bg-gray-200 hover:text-brand-gold transition-colors">
                            <Linkedin size={18} />
                        </button>
                        <a href="https://youtube.com/@careerchavadi?si=EOlknOdOjfgh8Pm1" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="p-2 bg-gray-100 rounded-full text-brand-textMuted hover:bg-gray-200 hover:text-brand-gold transition-colors">
                            <Youtube size={18} />
                        </a>
                        <a href="https://www.instagram.com/aigenius_ki_career_chavadi?igsh=eHA5N29vOGNjbzVv" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="p-2 bg-gray-100 rounded-full text-brand-textMuted hover:bg-gray-200 hover:text-brand-gold transition-colors">
                            <Instagram size={18} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
